import React, { useCallback, forwardRef } from 'react';
import debounce from 'lodash/debounce';
import CardList from '../CardList/CardList';
const defaultEventHandler = () => { };
function DragCardList(props, ref) {
    const { draggable = true, onDragStart = defaultEventHandler, onDragEnd = defaultEventHandler } = props;
    const debouceDragEnd = useCallback(debounce((event, item, index) => {
        onDragEnd && onDragEnd(event, item, index);
    }, 300), [onDragEnd]);
    const DragCardWrap = useCallback((dragProps) => {
        const { data, index, children } = dragProps;
        let cardDragable = typeof draggable === 'function' ? draggable(data, index) : draggable;
        const filterProps = Object.assign(Object.assign({}, dragProps), { data: undefined, index: undefined });
        return (React.createElement("div", Object.assign({}, filterProps, { draggable: cardDragable, onDragStart: e => {
                e.persist();
                onDragStart(e, data, index);
                debouceDragEnd(e, data, index);
            }, onDrag: e => {
                debouceDragEnd(e, data, index);
            }, onDragEnd: e => {
                e.persist();
                debouceDragEnd(e, data, index);
            } }), children));
    }, [draggable, onDragStart, debouceDragEnd]);
    return (React.createElement(CardList, Object.assign({ ref: ref, className: "u-vlist" }, props, { cardWrap: DragCardWrap })));
}
export default forwardRef(DragCardList);
